import { getBrandDetailsFromBrandJson } from "./share";

export function LocalizationIdentifier(): any {
    const dbaName = localStorage.getItem('dbaName');
    const countryCode = sessionStorage.getItem('countryCode');
    if (dbaName && countryCode) {
        return countryCode;
    }
    return null;
}
export async function getDisplayPhoneNumber(): Promise<string | null> {
    const localization = document.getElementById("weblocationId") as HTMLInputElement | null;
    let isLocalized = false;
    if (localization && Number(localization.value) > 0) {
        isLocalized = true;
    }
    let phoneNumber: string | null = localStorage.getItem('phoneNumber') ?? localStorage.getItem('localPhoneNumber');

    //If there is no phone number and if the user is not localized then fetch the phone number from the brand json
    if (!phoneNumber && !isLocalized) {
        const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
        if (conceptCode) {
            try {
                const brandData = await getBrandDetailsFromBrandJson(conceptCode);
                if (brandData) {
                    phoneNumber = brandData.phone;
                }
            } catch (error) {
                console.error('Error in fetching brand details for getDisplayPhoneNumber:', error);
            }
        }
    }
    return phoneNumber;
}

export function isLocalized(): boolean {
    const localization = localStorage.getItem('dbaName') as HTMLInputElement | null;
    let isLocalized = false;
    if (localization) {
        isLocalized = true;
    }
    return isLocalized;
}

 //To replace the local legal and neighbourly footer in localised Header National page scenario
 
 export function replaceLegalFooter(footerHTML: string): void {
    if (!footerHTML) return;

    const parser = new DOMParser();
    const newFooter = parser.parseFromString(footerHTML, 'text/html');
    const existingLegalFooter = document.querySelector('.legal-footer') as HTMLElement;
    const newLegalFooter = newFooter.querySelector('.legal-footer');

    if (newLegalFooter && existingLegalFooter) {
      existingLegalFooter.innerHTML = newLegalFooter.innerHTML;
    }
  }

  export function replaceNeighborlyFooter(footerHTML: string): void {
    if (!footerHTML) return;

    const parser = new DOMParser();
    const newFooter = parser.parseFromString(footerHTML, 'text/html');
    const existingSection = document.querySelector('.neighborly-ftr-section') as HTMLElement;
    const newSection = newFooter.querySelector('.neighborly-ftr-section');

    if (newSection && existingSection) {
      existingSection.innerHTML = newSection.innerHTML;
    }
  }
